'use client';
import React from 'react';
import { Col, Container, Placeholder, Row } from 'react-bootstrap';

export default function WideListingSkeleton() {
  return (
    <Container className="mt-5 mb-5" fluid>
      <Row>
        <Col xs={12}>
          <Placeholder
            xs={12}
            style={{ height: '540px', marginBottom: '20px' }}
          />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ height: '170px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ height: '170px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ height: '170px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ height: '170px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
      </Row>
    </Container>
  );
}
